(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2201],{

/***/ 11414:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ OfflineAuthGuardPopup; },
/* harmony export */   "u": function() { return /* binding */ OfflineAuthGuard; }
/* harmony export */ });
/* harmony import */ var app_components_icons_Offline__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64998);
/* harmony import */ var _ui_button_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61947);
/* harmony import */ var _offline_auth_guard_module_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(15062);
/* harmony import */ var _offline_auth_guard_module_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_offline_auth_guard_module_scss__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _auth_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35052);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var app_hooks_keyboard_navigation_hook__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36158);
/* harmony import */ var _ui_portal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64263);
/* harmony import */ var app_hooks_modal_scroll_hook__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(76299);
/* harmony import */ var app_hooks_lang__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(91289);
/* harmony import */ var app_hooks_go_back_hook__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(71014);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85893);













var OfflineAuthGuard = function OfflineAuthGuard(_ref) {
  var onClose = _ref.onClose;
  var t = (0,app_hooks_lang__WEBPACK_IMPORTED_MODULE_9__/* .useTranslate */ .q)();

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false),
      showAuth = _useState[0],
      setShowAuth = _useState[1];

  var goBackCallback = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function () {
    setShowAuth(false);
  }, [setShowAuth]);
  (0,app_hooks_go_back_hook__WEBPACK_IMPORTED_MODULE_7__/* .useGoBackEvent */ .H)("OfflineAuthGuard", goBackCallback, showAuth);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
    children: showAuth ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_auth_component__WEBPACK_IMPORTED_MODULE_2__/* .Auth */ .g, {
      onClose: onClose,
      onSuccess: onClose
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
      className: (_offline_auth_guard_module_scss__WEBPACK_IMPORTED_MODULE_10___default().no_account),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
        className: (_offline_auth_guard_module_scss__WEBPACK_IMPORTED_MODULE_10___default().icon),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(app_components_icons_Offline__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {})
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
        className: (_offline_auth_guard_module_scss__WEBPACK_IMPORTED_MODULE_10___default().content),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("h3", {
          className: (_offline_auth_guard_module_scss__WEBPACK_IMPORTED_MODULE_10___default().title),
          children: t("header.menu.offline")
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("p", {
          className: (_offline_auth_guard_module_scss__WEBPACK_IMPORTED_MODULE_10___default().subtitle),
          children: t("you-dont-have-podcasts")
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("p", {
          className: (_offline_auth_guard_module_scss__WEBPACK_IMPORTED_MODULE_10___default().subtitle),
          children: t("to-downaload-episodes")
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
          "data-navigate-row": true,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_ui_button_component__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
            onClick: function onClick() {
              return setShowAuth(true);
            },
            className: (_offline_auth_guard_module_scss__WEBPACK_IMPORTED_MODULE_10___default().button),
            "data-navigate-item": true,
            children: t("create-an-account")
          })
        }), onClose && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.Fragment, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("br", {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
            "data-navigate-row": true,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_ui_button_component__WEBPACK_IMPORTED_MODULE_1__/* .ButtonText */ .oD, {
              "data-navigate-item": true,
              onClick: function onClick() {
                return onClose();
              },
              className: (_offline_auth_guard_module_scss__WEBPACK_IMPORTED_MODULE_10___default().button),
              children: t("close")
            })
          })]
        })]
      })]
    })
  });
};
var OfflineAuthGuardPopup = function OfflineAuthGuardPopup(_ref2) {
  var onClose = _ref2.onClose;
  var wrapperRef = (0,app_hooks_keyboard_navigation_hook__WEBPACK_IMPORTED_MODULE_4__/* .useArrowKeyNavigationOverlay */ .Sy)();
  (0,app_hooks_modal_scroll_hook__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)();
  (0,app_hooks_go_back_hook__WEBPACK_IMPORTED_MODULE_7__/* .useGoBackEvent */ .H)("OfflineAuthGuardPopup", function () {
    onClose();
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_ui_portal__WEBPACK_IMPORTED_MODULE_5__/* .Portal */ .h, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
      className: (_offline_auth_guard_module_scss__WEBPACK_IMPORTED_MODULE_10___default().wrapper),
      ref: wrapperRef,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(OfflineAuthGuard, {
        onClose: onClose
      })
    })
  });
};

/***/ }),

/***/ 42924:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var Info = function Info(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", _objectSpread(_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 73 74",
    fill: "none"
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
      filter: "url(#prefix__filter0_d_6065_9895)",
      fill: "#fff",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M33.125 23.998a3 3 0 116 0 3 3 0 01-6 0zM33.125 35.998a3 3 0 016 0v12a3 3 0 01-6 0v-12z"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.125 35.998c0-16.56 13.44-30 30-30 16.56 0 30 13.44 30 30 0 16.56-13.44 30-30 30-16.56 0-30-13.44-30-30zm6 0c0 13.23 10.77 24 24 24s24-10.77 24-24-10.77-24-24-24-24 10.77-24 24z"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("defs", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("filter", {
        id: "prefix__filter0_d_6065_9895",
        x: 2.125,
        y: 5.998,
        width: 68,
        height: 68,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feColorMatrix", {
          in: "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feOffset", {
          dy: 4
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feGaussianBlur", {
          stdDeviation: 2
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feColorMatrix", {
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feBlend", {
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_6065_9895"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feBlend", {
          in: "SourceGraphic",
          in2: "effect1_dropShadow_6065_9895",
          result: "shape"
        })]
      })
    })]
  }));
};

var MemoInfo = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(Info);
/* harmony default export */ __webpack_exports__["Z"] = (MemoInfo);

/***/ }),

/***/ 64998:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var Offline = function Offline(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", _objectSpread(_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 206 206",
    fill: "none"
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("g", {
      clipPath: "url(#prefix__clip0_4408_9927)",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M153.677 104.03c6.18 0 11.33-5.15 11.33-11.33s-5.15-11.33-11.33-11.33-11.33 5.15-11.33 11.33 5.15 11.33 11.33 11.33zm0-14.42c1.648 0 3.09 1.442 3.09 3.09s-1.442 3.09-3.09 3.09-3.09-1.442-3.09-3.09 1.442-3.09 3.09-3.09zM90.641 60.77c0-2.884 2.266-5.15 5.15-5.15 2.884 0 5.15 2.266 5.15 5.15 0 2.884-2.266 5.15-5.15 5.15-2.884 0-5.15-2.472-5.15-5.15zM49.647 99.91c0 2.884-2.266 5.15-5.15 5.15-2.884 0-5.15-2.266-5.15-5.15 0-2.884 2.266-5.15 5.15-5.15 2.678 0 5.15 2.266 5.15 5.15zm9.682-12.154v-6.18h-6.18a4.132 4.132 0 01-4.12-4.12 4.132 4.132 0 014.12-4.12h6.18v-6.18a4.132 4.132 0 014.12-4.12 4.132 4.132 0 014.12 4.12v6.18h6.18a4.132 4.132 0 014.12 4.12 4.132 4.132 0 01-4.12 4.12h-6.18v6.18a4.132 4.132 0 01-4.12 4.12 4.132 4.132 0 01-4.12-4.12zM103 5.974C49.647 5.974 6.181 49.44 6.181 103v4.326c.206 2.884 1.442 5.768 3.708 7.622 1.236 1.03 2.472 1.648 3.914 2.06.412 2.06.618 4.12 1.236 6.18l2.678 13.596c-5.562 3.09-8.652 9.27-7.416 15.862l5.974 30.282c1.442 7.004 7.622 11.948 14.42 11.948 1.03 0 1.854 0 2.884-.206l11.536-2.266c.824 2.472 2.472 4.738 4.532 6.18 2.06 1.442 4.326 2.06 6.592 2.06.824 0 1.442 0 2.266-.206l10.3-2.06c3.09-.618 5.768-2.472 7.622-5.15 1.854-2.678 2.472-5.768 1.854-9.064L67.363 127.72c-1.236-6.386-7.622-10.712-14.008-9.476l-10.3 2.06c-3.09.618-5.768 2.472-7.622 5.15-1.442 2.266-2.266 4.738-2.06 7.416l-7.828 1.442-2.678-13.184c-.412-1.648-.824-3.502-1.03-5.356 3.502-1.854 5.768-5.768 5.562-10.094v-2.472-.618c0-36.874 28.222-58.71 75.19-58.71 46.968 0 75.602 22.248 75.602 59.122v2.884c-.206 4.326 2.06 8.24 5.768 10.094-.206 1.854-.618 3.708-1.03 5.356l-2.678 12.978-7.828-1.442c.206-2.678-.412-5.15-2.06-7.416-1.854-2.678-4.532-4.532-7.622-5.15l-10.3-2.06c-3.09-.618-6.386 0-9.064 1.854s-4.532 4.532-5.15 7.622l-10.506 56.65c-1.236 6.386 2.884 12.772 9.476 14.008l10.3 2.06c.824.206 1.442.206 2.266.206 5.15 0 9.682-3.296 11.33-8.24l11.536 2.266c1.03.206 1.854.206 2.884.206 7.004 0 13.184-4.944 14.42-11.948l5.768-30.282c1.236-6.592-1.854-12.772-7.416-15.862l2.678-13.596c.412-2.06.824-4.12 1.236-6.386 1.442-.412 2.678-1.236 3.914-2.06 2.266-1.854 3.708-4.738 3.708-7.622V103c0-53.56-43.466-97.026-96.82-97.026zM24.309 181.486l-5.974-30.488c-.412-1.854.206-3.708 1.236-5.15l4.326 21.836c.412 2.06 2.06 3.296 4.12 3.296h.824c2.266-.412 3.708-2.678 3.296-4.944l-4.738-23.484 7.622-1.442 8.446 43.26-7.416 1.442-1.442-7.416c-.412-2.266-2.678-3.708-4.944-3.296-2.266.412-3.708 2.678-3.296 4.944l1.236 5.974c-1.648-1.03-2.884-2.678-3.296-4.532zm20.394-52.942l10.3-2.06c2.06-.412 3.914 1.03 4.326 2.884l10.918 56.444c.206 1.03 0 2.06-.618 2.884-.618.824-1.442 1.442-2.472 1.648l-10.3 2.06c-2.06.412-3.914-1.03-4.326-2.884l-.412-2.472-4.944-25.75-5.562-28.222c-.206-2.06 1.03-4.12 3.09-4.532zm9.064-82.4l.412-.412c16.686-14.42 39.14-20.6 61.182-17.098 3.502.618 6.798 1.236 10.3 2.266 2.06.618 4.532-.618 5.15-2.678.618-2.266-.618-4.532-2.678-5.15-3.708-1.236-7.416-2.06-11.33-2.678-24.514-3.914-49.028 3.09-67.774 18.952-18.54 15.862-29.252 39.14-29.252 63.448v3.502c0 1.442-.824 2.678-2.266 2.678-.618 0-1.442-.206-2.06-.618-.412 0-1.03-.618-1.03-1.442V103c0-48.822 39.758-88.58 88.786-88.58 48.822 0 88.58 39.758 88.58 88.58v3.914c0 .824-.618 1.442-.824 1.648-.618.412-1.236.618-2.06.618-1.236-.206-2.266-1.236-2.266-2.678v-1.03c.824-32.548-17.51-63.036-46.762-77.456a4.128 4.128 0 00-5.562 1.854 4.128 4.128 0 001.854 5.562c5.974 2.884 11.33 6.592 16.274 10.918-13.184-6.592-29.87-10.094-49.44-10.094-19.57-.206-36.256 3.296-49.234 9.888zm95.172 146.26l-10.3-2.06c-2.06-.412-3.296-2.266-2.884-4.326l10.918-56.444c.412-2.06 2.266-3.296 4.326-2.884l10.3 2.06c2.06.412 3.296 2.266 2.884 4.326l-.412 2.472-1.854 9.476c-.412 2.266 1.03 4.326 3.296 4.738 2.266.412 4.326-1.03 4.738-3.296l1.03-5.562 7.21 1.442-8.446 43.26-7.004-1.236 4.944-25.544c.412-2.266-1.03-4.326-3.296-4.738-2.266-.412-4.326 1.03-4.738 3.296l-5.768 29.664-.618 2.472c-.412 1.854-2.266 3.296-4.326 2.884zm38.728-41.406l-5.974 30.282c-.412 2.06-1.648 3.708-3.296 4.532l8.034-39.964c1.03 1.442 1.648 3.296 1.236 5.15zM63.449 176.542l1.03 5.356c.412 2.266-1.03 4.326-3.296 4.738h-.824c-1.854 0-3.708-1.442-4.12-3.296l-1.03-5.356c-.412-2.266 1.03-4.326 3.296-4.738 2.472-.412 4.532 1.03 4.944 3.296zm-3.502-14.42c.206.206.412.412.412.618.206.206.206.412.412.618 0 .206.206.412.206.824v.824c0 1.03-.412 2.06-1.236 2.884-.824.824-1.854 1.236-2.884 1.236-1.03 0-2.06-.412-2.884-1.236-.824-.824-1.236-1.854-1.236-2.884 0-1.03.412-2.06 1.236-2.884 1.648-1.648 4.532-1.648 5.974 0zM47.38 136.99c-.412-2.266 1.03-4.326 3.296-4.738 2.266-.412 4.326 1.03 4.738 3.296l3.296 16.48c.412 2.266-1.03 4.326-3.296 4.738h-.824c-1.854 0-3.708-1.442-4.12-3.296l-3.09-16.48zm103.206 41.2l-1.03 5.356c-.412 2.06-2.06 3.296-4.12 3.296h-.824c-2.266-.412-3.708-2.678-3.296-4.738l1.03-5.356c.412-2.266 2.678-3.708 4.738-3.296 2.472.206 3.914 2.472 3.502 4.738zm8.034-41.2l-5.562 29.046c-.412 2.06-2.06 3.296-4.12 3.296h-.824c-2.266-.412-3.708-2.678-3.296-4.738l5.562-29.046c.412-2.266 2.678-3.708 4.738-3.296 2.472.412 3.914 2.678 3.502 4.738zm-29.87-62.624v-.618-.618c0-.206 0-.412-.206-.412 0-.206-.206-.206-.206-.412s-.206-.206-.206-.412-.206-.206-.206-.206l-.206-.206-.206-.206c-.206 0-.206-.206-.412-.206 0 0-.206 0-.206-.206-.206 0-.206-.206-.412-.206h-.206c-.206 0-.412-.206-.412-.206h-1.854l-28.84 6.18h-.206c-.206 0-.412.206-.618.206-.206 0-.206.206-.412.206s-.206.206-.412.206-.206.206-.412.206l-.206.206-.206.206s-.206.206-.206.412-.206.206-.206.412-.206.206-.206.412 0 .206-.206.412c0 .206 0 .206-.206.412v19.57a8.266 8.266 0 00-3.09-.618c-6.18 0-11.33 5.15-11.33 11.33s5.15 11.33 11.33 11.33 11.33-5.15 11.33-11.33V83.842l20.6-4.326v13.802a8.266 8.266 0 00-3.09-.618c-6.18 0-11.33 5.15-11.33 11.33s5.15 11.33 11.33 11.33 11.33-5.15 11.33-11.33V74.366zM88.581 113.3c-1.648 0-3.09-1.442-3.09-3.09s1.442-3.09 3.09-3.09 3.09 1.442 3.09 3.09-1.442 3.09-3.09 3.09zm28.84-6.18c-1.648 0-3.09-1.442-3.09-3.09s1.442-3.09 3.09-3.09 3.09 1.442 3.09 3.09-1.442 3.09-3.09 3.09z",
        fill: "#FFCA41"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("defs", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("clipPath", {
        id: "prefix__clip0_4408_9927",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
          fill: "#fff",
          transform: "scale(.69)",
          d: "M0 0h298.551v298.551H0z"
        })
      })
    })]
  }));
};

var MemoOffline = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(Offline);
/* harmony default export */ __webpack_exports__["Z"] = (MemoOffline);

/***/ }),

/***/ 96290:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Wave_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54825);
/* harmony import */ var _Wave_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Wave_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var Wave = function Wave(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 50 38.05",
    width: "1em",
    height: "1em"
  }, props), {}, {
    className: (_Wave_module_scss__WEBPACK_IMPORTED_MODULE_3___default().wave),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      "data-name": "Line 1",
      className: (_Wave_module_scss__WEBPACK_IMPORTED_MODULE_3___default().path),
      d: "M.91 15H.78A1 1 0 000 16v6a1 1 0 102 0v-6a1 1 0 00-1-1H.91z"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      "data-name": "Line 2",
      className: (_Wave_module_scss__WEBPACK_IMPORTED_MODULE_3___default().path),
      d: "M6.91 9h-.13A1 1 0 006 10v18a1 1 0 102 0V10a1 1 0 00-1-1h-.09z"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      "data-name": "Line 3",
      className: (_Wave_module_scss__WEBPACK_IMPORTED_MODULE_3___default().path),
      d: "M12.91 0h-.13A1 1 0 0012 1v36a1 1 0 102 0V1a1 1 0 00-1-1h-.09z"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      "data-name": "Line 4",
      className: (_Wave_module_scss__WEBPACK_IMPORTED_MODULE_3___default().path),
      d: "M18.91 10h-.12a1 1 0 00-.79 1v16a1 1 0 102 0V11a1 1 0 00-1-1h-.09z"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      "data-name": "Line 5",
      className: (_Wave_module_scss__WEBPACK_IMPORTED_MODULE_3___default().path),
      d: "M24.91 15h-.12a1 1 0 00-.79 1v6a1 1 0 002 0v-6a1 1 0 00-1-1h-.09z"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      "data-name": "Line 6",
      className: (_Wave_module_scss__WEBPACK_IMPORTED_MODULE_3___default().path),
      d: "M30.91 10h-.12a1 1 0 00-.79 1v16a1 1 0 102 0V11a1 1 0 00-1-1h-.09z"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      "data-name": "Line 7",
      className: (_Wave_module_scss__WEBPACK_IMPORTED_MODULE_3___default().path),
      d: "M36.91 0h-.13A1 1 0 0036 1v36a1 1 0 102 0V1a1 1 0 00-1-1h-.09z"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      "data-name": "Line 8",
      className: (_Wave_module_scss__WEBPACK_IMPORTED_MODULE_3___default().path),
      d: "M42.91 9h-.13a1 1 0 00-.78 1v18a1 1 0 102 0V10a1 1 0 00-1-1h-.09z"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      "data-name": "Line 9",
      className: (_Wave_module_scss__WEBPACK_IMPORTED_MODULE_3___default().path),
      d: "M48.91 15h-.12a1 1 0 00-.79 1v6a1 1 0 102 0v-6a1 1 0 00-1-1h-.09z"
    })]
  }));
};

var MemoWave = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(Wave);
/* harmony default export */ __webpack_exports__["Z"] = (MemoWave);

/***/ }),

/***/ 56736:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "m": function() { return /* binding */ ChapterItem; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./app/context/offline.context.tsx
var offline_context = __webpack_require__(85889);
// EXTERNAL MODULE: ./app/context/player.context.tsx
var player_context = __webpack_require__(48346);
// EXTERNAL MODULE: ./app/hooks/lang.ts + 22 modules
var lang = __webpack_require__(91289);
// EXTERNAL MODULE: ./app/hooks/navigation.hook.ts
var navigation_hook = __webpack_require__(26793);
// EXTERNAL MODULE: ./app/store/slices/player.ts
var player = __webpack_require__(22564);
// EXTERNAL MODULE: ./app/store/slices/user.ts
var user = __webpack_require__(38886);
// EXTERNAL MODULE: ./app/store/store.ts
var store = __webpack_require__(4062);
// EXTERNAL MODULE: ./app/utils/date.ts
var date = __webpack_require__(20811);
// EXTERNAL MODULE: ./app/utils/db.ts
var db = __webpack_require__(43007);
// EXTERNAL MODULE: ./app/utils/language.ts + 105 modules
var language = __webpack_require__(79490);
// EXTERNAL MODULE: ./app/utils/offline.ts + 1 modules
var offline = __webpack_require__(2358);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/parseISO/index.js
var parseISO = __webpack_require__(23855);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 21 modules
var format = __webpack_require__(19802);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./services-hooks/hooks.ts + 1 modules
var hooks = __webpack_require__(90413);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./app/components/icons/CheckMark.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var CheckMark = function CheckMark(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", _objectSpread(_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 27 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m10.582 20.027 10.13-13.021 1.54 1.981-11.67 15.003-6.222-7.997 1.542-1.981 4.68 6.015Z",
      fill: "#fff"
    })
  }));
};

var MemoCheckMark = /*#__PURE__*/(0,react.memo)(CheckMark);
/* harmony default export */ var icons_CheckMark = (MemoCheckMark);
;// CONCATENATED MODULE: ./app/components/icons/Delete.tsx


function Delete_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Delete_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Delete_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Delete_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





function Delete(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", Delete_objectSpread(Delete_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 256 256"
  }, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fill: "none",
      d: "M0 0h256v256H0z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 20,
      d: "M200 56L56 200M200 200L56 56"
    })]
  }));
}

var MemoDelete = /*#__PURE__*/react.memo(Delete);
/* harmony default export */ var icons_Delete = (MemoDelete);
// EXTERNAL MODULE: ./app/components/icons/Info.tsx
var Info = __webpack_require__(42924);
// EXTERNAL MODULE: ./app/components/icons/Loader.tsx
var Loader = __webpack_require__(37387);
// EXTERNAL MODULE: ./app/components/icons/OfflineOutline.tsx
var OfflineOutline = __webpack_require__(52659);
// EXTERNAL MODULE: ./app/components/icons/Play.tsx
var Play = __webpack_require__(43935);
;// CONCATENATED MODULE: ./app/components/icons/PodcastMenu.tsx


function PodcastMenu_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function PodcastMenu_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? PodcastMenu_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PodcastMenu_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var PodcastMenu = function PodcastMenu(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", PodcastMenu_objectSpread(PodcastMenu_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 1054 1054",
    fill: "none"
  }, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      opacity: 0.1,
      fill: "#fff",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M1054 527c0 291.054-235.946 527-527 527S0 818.054 0 527 235.946 0 527 0s527 235.946 527 527z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M1054 527c0 291.054-235.946 527-527 527S0 818.054 0 527 235.946 0 527 0s527 235.946 527 527z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M593.803 311.747c0 32.626-26.755 59.381-59.38 59.381v29.69c49.022 0 89.07-40.048 89.07-89.071h-29.69zm-59.38-59.38c32.625 0 59.38 26.755 59.38 59.38h29.69c0-49.022-40.048-89.07-89.07-89.07v29.69zm-59.381 59.38c0-32.625 26.755-59.38 59.381-59.38v-29.69c-49.023 0-89.071 40.048-89.071 89.07h29.69zm59.381 59.381c-32.626 0-59.381-26.755-59.381-59.381h-29.69c0 49.023 40.048 89.071 89.071 89.071v-29.69zm-59.381 163.295c0-32.625 26.755-59.38 59.381-59.38v-29.69c-49.023 0-89.071 40.048-89.071 89.07h29.69zm59.381 59.381c-32.626 0-59.381-26.755-59.381-59.381h-29.69c0 49.023 40.048 89.071 89.071 89.071v-29.69zm59.38-59.381c0 32.626-26.755 59.381-59.38 59.381v29.69c49.022 0 89.07-40.048 89.07-89.071h-29.69zm-59.38-59.38c32.625 0 59.38 26.755 59.38 59.38h29.69c0-49.022-40.048-89.07-89.07-89.07v29.69zm0 192.986c-49.023 0-89.071 40.047-89.071 89.07h29.69c0-32.625 26.755-59.38 59.381-59.38v-29.69zm89.07 89.07c0-49.023-40.048-89.07-89.07-89.07v29.69c32.625 0 59.38 26.755 59.38 59.38h29.69zm-89.07 89.07c49.022 0 89.07-40.047 89.07-89.07h-29.69c0 32.625-26.755 59.38-59.38 59.38v29.69zm-89.071-89.07c0 49.023 40.048 89.07 89.071 89.07v-29.69c-32.626 0-59.381-26.755-59.381-59.38h-29.69z",
      fill: "#C7C7C7"
    })]
  }));
};

var MemoPodcastMenu = /*#__PURE__*/react.memo(PodcastMenu);
/* harmony default export */ var icons_PodcastMenu = (MemoPodcastMenu);
// EXTERNAL MODULE: ./app/components/icons/Wave.tsx
var Wave = __webpack_require__(96290);
// EXTERNAL MODULE: ./app/components/toast/toast.component.tsx + 1 modules
var toast_component = __webpack_require__(53483);
// EXTERNAL MODULE: ./app/hooks/go-back.hook.ts
var go_back_hook = __webpack_require__(71014);
// EXTERNAL MODULE: ./app/hooks/keyboard-navigation.hook.ts
var keyboard_navigation_hook = __webpack_require__(36158);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useClickAway.js
var useClickAway = __webpack_require__(69293);
// EXTERNAL MODULE: ./app/components/ui/dropdown.module.scss
var dropdown_module = __webpack_require__(17382);
var dropdown_module_default = /*#__PURE__*/__webpack_require__.n(dropdown_module);
;// CONCATENATED MODULE: ./app/components/ui/dropdown.component.tsx








var Dropdown = function Dropdown(_ref) {
  var id = _ref.id,
      options = _ref.options,
      onClose = _ref.onClose,
      open = _ref.open;
  var goBackCallback = (0,react.useCallback)(function () {
    onClose();
  }, [onClose]);
  (0,go_back_hook/* useGoBackEvent */.H)("Dropdown", goBackCallback, open);

  var handleClick = function handleClick(e, option) {
    option.onClick();
    onClose();
    e.stopPropagation();
  };

  var wrapperRef = (0,keyboard_navigation_hook/* useArrowKeyNavigationOverlay */.Sy)(open);
  (0,useClickAway/* default */.Z)(wrapperRef, function (e) {
    var _e$composedPath;

    if (!(e !== null && e !== void 0 && (_e$composedPath = e.composedPath()) !== null && _e$composedPath !== void 0 && _e$composedPath.filter(function (item) {
      return item.id === id;
    }).length)) {
      onClose();
    }
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (0,clsx_m/* default */.Z)((dropdown_module_default()).wrapper),
    ref: wrapperRef,
    children: options.filter(function (option) {
      return !option.hidden;
    }).map(function (option, index) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        "data-navigate-row": open,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          "data-navigate-item": open,
          tabIndex: 0,
          className: (dropdown_module_default()).option,
          onClick: function onClick(e) {
            return handleClick(e, option);
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (dropdown_module_default()).icon_wrapper,
            children: option.icon
          }), option.title]
        })
      }, "dropdown-".concat(id, "-").concat(index));
    })
  });
};
// EXTERNAL MODULE: ./app/components/podcast-view/chapter-item.module.scss
var chapter_item_module = __webpack_require__(2475);
var chapter_item_module_default = /*#__PURE__*/__webpack_require__.n(chapter_item_module);
;// CONCATENATED MODULE: ./app/components/podcast-view/chapter-item.component.tsx































var ChapterItem = function ChapterItem(_ref) {
  var _playerState$activeMe, _playerState$activeMe2, _playerState$activeMe3;

  var progress = _ref.progress,
      chapter = _ref.chapter,
      podcast = _ref.podcast,
      index = _ref.index,
      downloadAvailable = _ref.downloadAvailable,
      startPlayback = _ref.startPlayback,
      showOfflineAuthGuard = _ref.showOfflineAuthGuard,
      redirectToPodcast = _ref.redirectToPodcast,
      _ref$authCallback = _ref.authCallback,
      authCallback = _ref$authCallback === void 0 ? function () {} : _ref$authCallback,
      _ref$reloadProgress = _ref.reloadProgress,
      reloadProgress = _ref$reloadProgress === void 0 ? function () {} : _ref$reloadProgress;
  var playerState = (0,store/* useAppSelector */.CG)(player/* selectPlayerState */.tA);

  var _useAppSelector = (0,store/* useAppSelector */.CG)(user/* selectUserState */.tH),
      session = _useAppSelector.session;

  var _usePlayerContext = (0,player_context/* usePlayerContext */.gD)(),
      isPlaying = _usePlayerContext.isPlaying,
      isMediaLoading = _usePlayerContext.isMediaLoading;

  var _useOfflineContext = (0,offline_context/* useOfflineContext */.tw)(),
      offlineChapters = _useOfflineContext.offlineChapters;

  var _useState = (0,react.useState)(false),
      showDropdown = _useState[0],
      setShowDropdown = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isDownloading = _useState2[0],
      setIsDownloading = _useState2[1];

  var goToPodcast = (0,navigation_hook/* useGoToPodcast */.IT)();
  var t = (0,lang/* useTranslate */.q)();
  var deleteToast = (0,toast_component/* useToast */.pm)({
    content: t("offline.remove-success-toast")
  });

  var _usePostPillowListenV = (0,hooks/* usePostPillowListenV2ProgressChapter_id */.ZH)(),
      postChapterProgress = _usePostPillowListenV.mutateAsync;

  var _useState3 = (0,react.useState)({
    percentage: 0,
    progressMB: "0",
    total: 0
  }),
      downloadProgress = _useState3[0],
      setDownloadProgress = _useState3[1];

  var offlineErrorToast = (0,toast_component/* useErrorToast */.cM)({
    content: t("offline.save-error-toast")
  });
  var offlineSuccessToast = (0,toast_component/* useToast */.pm)({
    content: t("offline.save-success-toast")
  });
  var offlineStartToast = (0,toast_component/* useToast */.pm)({
    content: t("offline.save-in-progress-toast")
  });

  var formatPublishDate = function formatPublishDate(dateString) {
    try {
      var parsedDate = (0,parseISO/* default */.Z)(dateString);
      return (0,format/* default */.Z)(parsedDate, "d MMM yyyy", {
        locale: (0,language/* getDateFnsLocale */.Gr)()
      });
    } catch (e) {
      console.error(e);
      return "";
    }
  };

  var downloadEpisodeClickHandler = function downloadEpisodeClickHandler(chapter, playbackProgressSeconds) {
    if (session !== null && session !== void 0 && session.user) {
      offlineStartToast();
      setIsDownloading(true);
      (0,offline/* downloadEpisode */.K)(chapter, podcast, playbackProgressSeconds, updateProgress, function () {
        setDownloadProgress({
          percentage: 0,
          progressMB: "0",
          total: 0
        });
        offlineSuccessToast();
        setIsDownloading(false);
      }, function () {
        setDownloadProgress({
          percentage: 0,
          progressMB: "0",
          total: 0
        });
        offlineErrorToast();
        setIsDownloading(false);
      });
    } else {
      showOfflineAuthGuard();
    }
  };

  var updateProgress = function updateProgress(progressBytes) {
    setDownloadProgress(progressBytes);
  };

  var offlineChapter = offlineChapters === null || offlineChapters === void 0 ? void 0 : offlineChapters.find(function (offlineChapter) {
    return offlineChapter.permalink === chapter.permalink;
  });
  var hasBeenDownloaded = !!offlineChapter;
  var markChapterAsPlayed = (0,react.useCallback)( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(session !== null && session !== void 0 && session.user)) {
              _context.next = 12;
              break;
            }

            if (hasBeenDownloaded) {
              db.db.offlineChapters.update(chapter.permalink, {
                isPlayed: false,
                playbackProgress: chapter.duration
              });
            }

            _context.prev = 2;
            _context.next = 5;
            return postChapterProgress({
              chapter_id: chapter.permalink,
              requestBody: {
                finished: true,
                seconds: chapter.duration
              }
            });

          case 5:
            _context.next = 9;
            break;

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](2);

          case 9:
            reloadProgress();
            _context.next = 13;
            break;

          case 12:
            authCallback();

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 7]]);
  })), [session === null || session === void 0 ? void 0 : session.user, hasBeenDownloaded, chapter.permalink]);

  var getDropdownOptions = function getDropdownOptions() {
    return [{
      title: t("go-to-podcast"),
      onClick: function onClick() {
        goToPodcast("/".concat(podcast.permalink));
      },
      icon: /*#__PURE__*/(0,jsx_runtime.jsx)(Info/* default */.Z, {
        className: (chapter_item_module_default()).rotate_button
      }),
      hidden: !redirectToPodcast
    }, {
      title: t("offline.download-episode"),
      onClick: function onClick() {
        return downloadEpisodeClickHandler(chapter, (progress === null || progress === void 0 ? void 0 : progress.seconds) || 0);
      },
      icon: /*#__PURE__*/(0,jsx_runtime.jsx)(OfflineOutline/* default */.Z, {
        className: (chapter_item_module_default()).offline_icon
      }),
      hidden: !downloadAvailable || hasBeenDownloaded
    }, {
      title: t("mark-as-played"),
      onClick: markChapterAsPlayed,
      icon: /*#__PURE__*/(0,jsx_runtime.jsx)(icons_CheckMark, {
        className: (0,clsx_m/* default */.Z)((chapter_item_module_default()).rotate_button, (chapter_item_module_default()).check_icon)
      }),
      hidden: offlineChapter === null || offlineChapter === void 0 ? void 0 : offlineChapter.isPlayed
    }, {
      title: t("delete"),
      onClick: function onClick() {
        db.db.offlineChapters["delete"](chapter.permalink).then(function () {
          deleteToast();
        });
      },
      icon: /*#__PURE__*/(0,jsx_runtime.jsx)(icons_Delete, {}),
      hidden: !hasBeenDownloaded
    }];
  };

  var optionsId = "".concat(chapter.permalink, "-options-button");
  var isChapterSelected = (playerState === null || playerState === void 0 ? void 0 : (_playerState$activeMe = playerState.activeMedia) === null || _playerState$activeMe === void 0 ? void 0 : (_playerState$activeMe2 = _playerState$activeMe.podcast) === null || _playerState$activeMe2 === void 0 ? void 0 : (_playerState$activeMe3 = _playerState$activeMe2.podcastChapter) === null || _playerState$activeMe3 === void 0 ? void 0 : _playerState$activeMe3.permalink) === (chapter === null || chapter === void 0 ? void 0 : chapter.permalink);
  var isChapterPlaying = isChapterSelected && isPlaying;
  var isChapterLoading = isChapterSelected && isMediaLoading;
  var closeDropdownCallback = (0,react.useCallback)(function () {
    return setShowDropdown(false);
  }, [setShowDropdown]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (0,clsx_m/* default */.Z)((chapter_item_module_default()).podcast_chapter_wrapper, (0,defineProperty/* default */.Z)({}, (chapter_item_module_default()).active, isChapterSelected)),
    "data-navigate-row": true,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (0,clsx_m/* default */.Z)((chapter_item_module_default()).podcast_chapter_main),
      "data-navigate-item": true,
      tabIndex: 0,
      onClick: function onClick() {
        return startPlayback(chapter, index);
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (chapter_item_module_default()).cover_wrapper,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          className: (chapter_item_module_default()).cover,
          src: chapter.logo,
          alt: chapter.name
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (chapter_item_module_default()).hover_overlay,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (chapter_item_module_default()).svg_wrapper,
            children: isChapterLoading ? /*#__PURE__*/(0,jsx_runtime.jsx)(Loader/* default */.Z, {}) : isChapterPlaying ? /*#__PURE__*/(0,jsx_runtime.jsx)(Wave/* default */.Z, {}) : /*#__PURE__*/(0,jsx_runtime.jsx)(Play/* default */.Z, {})
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (chapter_item_module_default()).podcast_chapter,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (chapter_item_module_default()).podcast_chapter_details,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
            children: chapter.name
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: (chapter_item_module_default()).podcast_chapter_description,
            children: chapter.summary || chapter.name
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (chapter_item_module_default()).podcast_chapter_seek_time,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            children: [formatPublishDate((chapter === null || chapter === void 0 ? void 0 : chapter.published) || ""), " -", " ", (0,date/* formatTimeWithUnits */.G)(chapter.duration, t)]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (chapter_item_module_default()).podcast_chapter_seek_wrapper,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (chapter_item_module_default()).podcast_chapter_seek_bar,
            children: isDownloading ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (0,clsx_m/* default */.Z)((chapter_item_module_default()).podcast_chapter_seek_bar_inner, (chapter_item_module_default()).podcast_chapter_progress_bar_inner),
              style: {
                width: "".concat(downloadProgress.percentage, "%")
              },
              children: "\xA0"
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (chapter_item_module_default()).podcast_chapter_seek_bar_inner,
              style: {
                width: progress && chapter.duration ? "".concat(progress.seconds / chapter.duration * 100, "%") : undefined
              },
              children: "\xA0"
            })
          }), isDownloading && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (chapter_item_module_default()).text_download_progress,
            children: [downloadProgress.progressMB, "MB of ", downloadProgress.total, "MB"]
          })]
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      "data-navigate-item": true,
      tabIndex: 0,
      id: optionsId,
      className: (0,clsx_m/* default */.Z)((chapter_item_module_default()).podcast_chapter_controls_wrapper, (chapter_item_module_default()).podcast_chapter_controls_more, (0,defineProperty/* default */.Z)({}, (chapter_item_module_default()).show_dropdown, showDropdown)),
      onClick: function onClick() {
        return setShowDropdown(function (showDropdown) {
          return !showDropdown;
        });
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(icons_PodcastMenu, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (chapter_item_module_default()).dropdown_wrapper,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Dropdown, {
          open: showDropdown,
          onClose: closeDropdownCallback,
          id: chapter.permalink,
          options: getDropdownOptions()
        })
      })]
    })]
  });
};

/***/ }),

/***/ 863:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ usePlayback; }
/* harmony export */ });
/* harmony import */ var app_context_player_context__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48346);
/* harmony import */ var app_store_slices_player__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22564);
/* harmony import */ var app_store_store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4062);



var usePlayback = function usePlayback() {
  var _usePlayerContext = (0,app_context_player_context__WEBPACK_IMPORTED_MODULE_0__/* .usePlayerContext */ .gD)(),
      setPlayerEnabled = _usePlayerContext.setPlayerEnabled,
      setIsPlaying = _usePlayerContext.setIsPlaying,
      setFullscreenPlayerInitialyOpen = _usePlayerContext.setFullscreenPlayerInitialyOpen;

  var dispatch = (0,app_store_store__WEBPACK_IMPORTED_MODULE_2__/* .useAppDispatch */ .TL)();
  var playerState = (0,app_store_store__WEBPACK_IMPORTED_MODULE_2__/* .useAppSelector */ .CG)(app_store_slices_player__WEBPACK_IMPORTED_MODULE_1__/* .selectPlayerState */ .tA);

  var startChapterPlayback = function startChapterPlayback(chapter, index, chapterList, podcast) {
    var _playerState$activeMe, _playerState$activeMe2, _playerState$activeMe3;

    setFullscreenPlayerInitialyOpen(true);
    setPlayerEnabled(true);

    if ((playerState === null || playerState === void 0 ? void 0 : (_playerState$activeMe = playerState.activeMedia) === null || _playerState$activeMe === void 0 ? void 0 : (_playerState$activeMe2 = _playerState$activeMe.podcast) === null || _playerState$activeMe2 === void 0 ? void 0 : (_playerState$activeMe3 = _playerState$activeMe2.podcastChapter) === null || _playerState$activeMe3 === void 0 ? void 0 : _playerState$activeMe3.permalink) !== (chapter === null || chapter === void 0 ? void 0 : chapter.permalink)) {
      dispatch(app_store_slices_player__WEBPACK_IMPORTED_MODULE_1__/* .playerActions.selectTrack */ .i9.selectTrack({
        category: null,
        podcast: {
          podcast: podcast,
          podcastChapter: chapter
        }
      }));
    } else {
      setIsPlaying(true);
    }

    dispatch(app_store_slices_player__WEBPACK_IMPORTED_MODULE_1__/* .playerActions.setPodcastQueue */ .i9.setPodcastQueue({
      items: chapterList,
      activeIndex: index
    }));
  };

  var stopPlayback = function stopPlayback() {
    setIsPlaying(false);
  };

  return {
    startChapterPlayback: startChapterPlayback,
    stopPlayback: stopPlayback
  };
};

/***/ }),

/***/ 20811:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ formatTimeWithUnits; }
/* harmony export */ });
/* unused harmony export formatTime */
var formatTime = function formatTime(seconds) {
  if (seconds !== undefined) {
    var secondsDiff = seconds;
    var hoursDiff = Math.floor(secondsDiff / 3600);
    secondsDiff -= hoursDiff * 3600;
    var minutesDiff = Math.floor(secondsDiff / 60);
    secondsDiff -= minutesDiff * 60;
    secondsDiff |= 0;
    return "".concat(hoursDiff.toString().padStart(2, "0"), ":").concat(minutesDiff.toString().padStart(2, "0"), ":").concat(secondsDiff.toString().padStart(2, "0"));
  }

  return "";
};
var formatTimeWithUnits = function formatTimeWithUnits(seconds, t) {
  if (seconds !== undefined) {
    var secondsDiff = seconds;
    var hoursDiff = Math.floor(secondsDiff / 3600);
    secondsDiff -= hoursDiff * 3600;
    var minutesDiff = Math.floor(secondsDiff / 60);
    secondsDiff -= minutesDiff * 60;
    secondsDiff |= 0;
    var result = '';

    if (hoursDiff) {
      result += "".concat(hoursDiff.toString().padStart(2, "0"), " ").concat(t('time.h'), " ");
    }

    if (minutesDiff) {
      result += "".concat(minutesDiff.toString().padStart(2, "0"), " ").concat(t('time.min'), " ");
    }

    if (secondsDiff) {
      result += "".concat(secondsDiff.toString().padStart(2, "0"), " ").concat(t('time.s'), " ");
    }

    return result;
  }

  return "";
};

/***/ }),

/***/ 2358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "R": function() { return /* binding */ checkIfCanBeDownloaded; },
  "K": function() { return /* binding */ downloadEpisode; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./services-hooks/services.ts + 1 modules
var services = __webpack_require__(46725);
// EXTERNAL MODULE: ./app/utils/db.ts
var db = __webpack_require__(43007);
// EXTERNAL MODULE: ./app/context/country.context.tsx
var country_context = __webpack_require__(91537);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
;// CONCATENATED MODULE: ./app/utils/downloadErrorTracker.ts



var sendPodcastDownloadError = function sendPodcastDownloadError(permalink, chapterPermalink) {
  try {
    var ip = '';

    if (window) {
      var _JSON$parse;

      var country = window.localStorage.getItem(country_context/* LOCAL_STORAGE_COUNTRY_KEY */.VL);
      ip = country ? (_JSON$parse = JSON.parse(country)) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.ip : '';
    }

    axios_default()({
      method: 'get',
      url: '/api/google-api/download-error',
      params: {
        data: {
          permalink: permalink,
          chapterPermalink: chapterPermalink,
          ip: ip,
          date: new Date()
        }
      }
    });
  } catch (e) {
    console.error(e);
  }
};

/* harmony default export */ var downloadErrorTracker = (sendPodcastDownloadError);
;// CONCATENATED MODULE: ./app/utils/offline.ts





var checkIfCanBeDownloaded = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(episode, successCallback, errorCallback) {
    var _playData$body, _playData$body$conten, _playData$body$conten2, _playData$body2, _playData$body2$conte, _playData$body2$conte2;

    var _yield$getPillowPodca, playData, currentStreamIndex, streamCount, streamUrl, streams, handleXHRError, sendRequest;

    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return (0,services/* getPillowPodcastchapterPlay */.nU)(episode.permalink);

          case 2:
            _yield$getPillowPodca = _context2.sent;
            playData = _yield$getPillowPodca.data;
            currentStreamIndex = 0;
            streamCount = (playData === null || playData === void 0 ? void 0 : (_playData$body = playData.body) === null || _playData$body === void 0 ? void 0 : (_playData$body$conten = _playData$body.content) === null || _playData$body$conten === void 0 ? void 0 : (_playData$body$conten2 = _playData$body$conten.streams) === null || _playData$body$conten2 === void 0 ? void 0 : _playData$body$conten2.length) || 0;

            if (playData !== null && playData !== void 0 && (_playData$body2 = playData.body) !== null && _playData$body2 !== void 0 && (_playData$body2$conte = _playData$body2.content) !== null && _playData$body2$conte !== void 0 && (_playData$body2$conte2 = _playData$body2$conte.streams) !== null && _playData$body2$conte2 !== void 0 && _playData$body2$conte2.length) {
              streamUrl = playData.body.content.streams[0].url;
              streams = playData.body.content.streams;

              handleXHRError = function handleXHRError(xhr) {
                xhr.abort();

                if (currentStreamIndex < streamCount - 1 && streams[currentStreamIndex + 1].url) {
                  currentStreamIndex++;
                  sendRequest(streams[currentStreamIndex].url);
                } else if (errorCallback) {
                  if (episode.podcastPermalink && episode.permalink) {
                    downloadErrorTracker(episode.podcastPermalink, episode.permalink);
                  }

                  errorCallback();
                }
              };

              sendRequest = function sendRequest(fileUrl) {
                var xhr = new XMLHttpRequest();
                xhr.timeout = 2000;
                xhr.open("HEAD", fileUrl, true);
                xhr.addEventListener("timeout", function () {
                  return handleXHRError(xhr);
                });
                xhr.addEventListener("error", function () {
                  return handleXHRError(xhr);
                });
                xhr.addEventListener("load", /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
                  return regenerator_default().wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          if ([200, 302, 304].includes(xhr.status)) {
                            successCallback();
                          } else {
                            xhr.abort();

                            if (currentStreamIndex < streamCount - 1 && streams[currentStreamIndex + 1].url) {
                              currentStreamIndex++;
                              sendRequest(streams[currentStreamIndex].url);
                            } else if (errorCallback) {
                              if (episode.podcastPermalink && episode.permalink) {
                                downloadErrorTracker(episode.podcastPermalink, episode.permalink);
                              }

                              errorCallback();
                            }
                          }

                        case 1:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                })), false);
                xhr.send();
              };

              sendRequest(streamUrl);
            }

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function checkIfCanBeDownloaded(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
var downloadEpisode = /*#__PURE__*/function () {
  var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4(episode, podcast, playbackProgress, updateProgress, successCallback, errorCallback) {
    var _offlineData$body, _offlineData$body$con, _offlineData$body$con2, _offlineData$body2, _offlineData$body2$co, _offlineData$body2$co2, _yield$getPillowPodca2, offlineData, podcastLogoBase64, chapterLogoBase64, podcastLogo, chapterLogo, _currentStreamIndex, _streamCount, streamUrl, _streams, _sendRequest;

    return regenerator_default().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return (0,services/* getPillowPodcastchapterPlay */.nU)(episode.permalink);

          case 3:
            _yield$getPillowPodca2 = _context4.sent;
            offlineData = _yield$getPillowPodca2.data;
            podcastLogoBase64 = "";
            chapterLogoBase64 = "";
            podcastLogo = new Image();
            podcastLogo.crossOrigin = "Anonymous";

            podcastLogo.onload = function () {
              var canvas = document.createElement("CANVAS");
              var ctx = canvas.getContext("2d");
              canvas.height = podcastLogo.naturalHeight;
              canvas.width = podcastLogo.naturalWidth;
              ctx === null || ctx === void 0 ? void 0 : ctx.drawImage(podcastLogo, 0, 0);
              podcastLogoBase64 = canvas.toDataURL("image/jpeg");
            };

            podcastLogo.src = podcast.logo || (podcast === null || podcast === void 0 ? void 0 : podcast.smallLogo) || "";
            chapterLogo = new Image();
            chapterLogo.crossOrigin = "Anonymous";

            chapterLogo.onload = function () {
              var canvas = document.createElement("CANVAS");
              var ctx = canvas.getContext("2d");
              canvas.height = chapterLogo.naturalHeight;
              canvas.width = chapterLogo.naturalWidth;
              ctx === null || ctx === void 0 ? void 0 : ctx.drawImage(chapterLogo, 0, 0);
              chapterLogoBase64 = canvas.toDataURL("image/jpeg");
            };

            chapterLogo.src = episode.logo || (episode === null || episode === void 0 ? void 0 : episode.smallLogo) || "";
            _currentStreamIndex = 0;
            _streamCount = (offlineData === null || offlineData === void 0 ? void 0 : (_offlineData$body = offlineData.body) === null || _offlineData$body === void 0 ? void 0 : (_offlineData$body$con = _offlineData$body.content) === null || _offlineData$body$con === void 0 ? void 0 : (_offlineData$body$con2 = _offlineData$body$con.streams) === null || _offlineData$body$con2 === void 0 ? void 0 : _offlineData$body$con2.length) || 0;

            if (offlineData !== null && offlineData !== void 0 && (_offlineData$body2 = offlineData.body) !== null && _offlineData$body2 !== void 0 && (_offlineData$body2$co = _offlineData$body2.content) !== null && _offlineData$body2$co !== void 0 && (_offlineData$body2$co2 = _offlineData$body2$co.streams) !== null && _offlineData$body2$co2 !== void 0 && _offlineData$body2$co2.length) {
              streamUrl = offlineData.body.content.streams[0].url;
              _streams = offlineData.body.content.streams;

              _sendRequest = function _sendRequest(fileUrl) {
                var fileBlob;
                var xhr = new XMLHttpRequest();
                xhr.open("GET", fileUrl, true);
                xhr.responseType = "blob";
                xhr.addEventListener("progress", function (e) {
                  if (updateProgress) {
                    var percentage = Math.round(e.loaded / e.total * 100);
                    var progressMB = Number(e.loaded / 1024 / 1024).toPrecision(3);
                    var total = Math.round(e.total / 1024 / 1024);
                    updateProgress({
                      percentage: percentage,
                      progressMB: progressMB,
                      total: total
                    });
                  }
                });
                xhr.addEventListener("error", function () {
                  xhr.abort();

                  if (_currentStreamIndex < _streamCount - 1 && _streams[_currentStreamIndex + 1].url) {
                    _currentStreamIndex++;

                    _sendRequest(_streams[_currentStreamIndex].url);
                  } else if (errorCallback) {
                    if (episode.podcastPermalink && episode.permalink) {
                      downloadErrorTracker(episode.podcastPermalink, episode.permalink);
                    }

                    errorCallback();
                  }
                });
                xhr.addEventListener("load", /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3() {
                  var episodeCopy, podcastCopy, permalinkKey;
                  return regenerator_default().wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          if (!(xhr.status === 200)) {
                            _context3.next = 19;
                            break;
                          }

                          fileBlob = xhr.response;
                          episodeCopy = JSON.parse(JSON.stringify(episode));
                          episodeCopy.logo = chapterLogoBase64;
                          podcastCopy = JSON.parse(JSON.stringify(podcast));
                          podcastCopy.logo = podcastLogoBase64;
                          _context3.prev = 6;
                          _context3.next = 9;
                          return db.db.offlineChapters.add({
                            chapter: episodeCopy,
                            permalink: episode.permalink,
                            podcast: podcastCopy,
                            file: fileBlob,
                            playbackProgress: playbackProgress,
                            isPlayed: playbackProgress === episodeCopy.duration
                          });

                        case 9:
                          permalinkKey = _context3.sent;

                          if (successCallback) {
                            successCallback();
                          }

                          _context3.next = 17;
                          break;

                        case 13:
                          _context3.prev = 13;
                          _context3.t0 = _context3["catch"](6);
                          xhr.abort();

                          if (_currentStreamIndex < _streamCount - 1 && _streams[_currentStreamIndex + 1].url) {
                            _currentStreamIndex++;

                            _sendRequest(_streams[_currentStreamIndex].url);
                          } else if (errorCallback) {
                            if (episode.podcastPermalink && episode.permalink) {
                              downloadErrorTracker(episode.podcastPermalink, episode.permalink);
                            }

                            errorCallback();
                          }

                        case 17:
                          _context3.next = 21;
                          break;

                        case 19:
                          xhr.abort();

                          if (_currentStreamIndex < _streamCount - 1 && _streams[_currentStreamIndex + 1].url) {
                            _currentStreamIndex++;

                            _sendRequest(_streams[_currentStreamIndex].url);
                          } else if (errorCallback) {
                            if (episode.podcastPermalink && episode.permalink) {
                              downloadErrorTracker(episode.podcastPermalink, episode.permalink);
                            }

                            errorCallback();
                          }

                        case 21:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3, null, [[6, 13]]);
                })), false);
                xhr.send();
              };

              _sendRequest(streamUrl);
            }

            _context4.next = 24;
            break;

          case 20:
            _context4.prev = 20;
            _context4.t0 = _context4["catch"](0);

            if (episode.podcastPermalink && episode.permalink) {
              downloadErrorTracker(episode.podcastPermalink, episode.permalink);
            }

            errorCallback && errorCallback();

          case 24:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 20]]);
  }));

  return function downloadEpisode(_x4, _x5, _x6, _x7, _x8, _x9) {
    return _ref3.apply(this, arguments);
  };
}();

/***/ }),

/***/ 15062:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressColorPrimaryMuted":"rgba(0,0,0,0)","progressColorFill":"#ffca41","progressColorPrimary":"#ffca41","contentMaxWidth":"192rem","wrapper":"offline-auth-guard_wrapper__gRVvC","no_account":"offline-auth-guard_no_account__IUOaI","content":"offline-auth-guard_content__bTKLV","title":"offline-auth-guard_title__26YWx","subtitle":"offline-auth-guard_subtitle__8ghXg","with_icon":"offline-auth-guard_with_icon__yiODK","icon_wrapper":"offline-auth-guard_icon_wrapper__tlzOX","button":"offline-auth-guard_button__e2U7K","icon":"offline-auth-guard_icon__ZKNE3"};

/***/ }),

/***/ 54825:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wave":"Wave_wave__feeJT","path":"Wave_path__J3SuJ","pulse":"Wave_pulse__HVwY5"};

/***/ }),

/***/ 2475:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressColorPrimaryMuted":"rgba(0,0,0,0)","progressColorFill":"#ffca41","progressColorPrimary":"#ffca41","contentMaxWidth":"192rem","podcast_chapter_wrapper":"chapter-item_podcast_chapter_wrapper__U7fbe","podcast_chapter_controls_more":"chapter-item_podcast_chapter_controls_more__3qLMo","hover_overlay":"chapter-item_hover_overlay__aNuDW","podcast_chapter_seek_bar_inner":"chapter-item_podcast_chapter_seek_bar_inner__tX0er","active":"chapter-item_active__c0gQR","cover_wrapper":"chapter-item_cover_wrapper__pPo_d","podcast_chapter_main":"chapter-item_podcast_chapter_main__fwyhk","cover":"chapter-item_cover__pQ35H","svg_wrapper":"chapter-item_svg_wrapper__Dkdyt","podcast_chapter":"chapter-item_podcast_chapter__u5G1E","podcast_chapter_date":"chapter-item_podcast_chapter_date__vGSH0","podcast_chapter_details":"chapter-item_podcast_chapter_details__KqL4o","podcast_chapter_description":"chapter-item_podcast_chapter_description__H6piN","podcast_chapter_seek_time":"chapter-item_podcast_chapter_seek_time__AJRkp","podcast_chapter_seek_wrapper":"chapter-item_podcast_chapter_seek_wrapper__4x58R","podcast_chapter_seek_bar":"chapter-item_podcast_chapter_seek_bar__VW7IY","podcast_chapter_progress_bar_inner":"chapter-item_podcast_chapter_progress_bar_inner__MB9B1","text_download_progress":"chapter-item_text_download_progress__aP9TT","podcast_chapter_controls_wrapper":"chapter-item_podcast_chapter_controls_wrapper__bjKSK","dropdown_wrapper":"chapter-item_dropdown_wrapper__NN2CJ","show_dropdown":"chapter-item_show_dropdown__TJlry","check_icon":"chapter-item_check_icon__1bapx","filled_button":"chapter-item_filled_button__THxHX","show_progress":"chapter-item_show_progress__hGVRW","podcast_chapter_controls_offline_svg_wrapper":"chapter-item_podcast_chapter_controls_offline_svg_wrapper__r5cxZ","podcast_chapter_controls_progress":"chapter-item_podcast_chapter_controls_progress__YdSnG"};

/***/ }),

/***/ 17382:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressColorPrimaryMuted":"rgba(0,0,0,0)","progressColorFill":"#ffca41","progressColorPrimary":"#ffca41","contentMaxWidth":"192rem","option":"dropdown_option__UPQAB","wrapper":"dropdown_wrapper__pgrh7","icon_wrapper":"dropdown_icon_wrapper__UrJGC"};

/***/ }),

/***/ 69293:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _misc_util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76362);


var defaultEvents = ['mousedown', 'touchstart'];
var useClickAway = function (ref, onClickAway, events) {
    if (events === void 0) { events = defaultEvents; }
    var savedCallback = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(onClickAway);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        savedCallback.current = onClickAway;
    }, [onClickAway]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        var handler = function (event) {
            var el = ref.current;
            el && !el.contains(event.target) && savedCallback.current(event);
        };
        for (var _i = 0, events_1 = events; _i < events_1.length; _i++) {
            var eventName = events_1[_i];
            (0,_misc_util__WEBPACK_IMPORTED_MODULE_1__.on)(document, eventName, handler);
        }
        return function () {
            for (var _i = 0, events_2 = events; _i < events_2.length; _i++) {
                var eventName = events_2[_i];
                (0,_misc_util__WEBPACK_IMPORTED_MODULE_1__/* .off */ .S1)(document, eventName, handler);
            }
        };
    }, [events, ref]);
};
/* harmony default export */ __webpack_exports__["Z"] = (useClickAway);


/***/ })

}]);